import lubricantsList from './List'
import lubricantsShow from './Show'
import lubricantsEdit from './Edit'

const lubricantsResource = {
  list: lubricantsList,
  show: lubricantsShow,
  edit: lubricantsEdit,
}

export default lubricantsResource
